import React from 'react';
import { Link } from 'react-router-dom';

const ExploreFeatures = () => {
  const comedians = [
    {
      name: 'Dave Chappelle',
      image: 'https://res.cloudinary.com/dbm8xbouw/image/upload/v1775911790/d57gxekdlklduddgqs9v.jpg'
    },
    {
      name: 'Daniel Tosh',
      image: 'https://res.cloudinary.com/dbm8xbouw/image/upload/v1775911645/i5wtlumjqyqy2wx1ebqz.png'
    },
    {
      name: 'Patrice ONeal',
      image: 'https://res.cloudinary.com/dbm8xbouw/image/upload/v1775911868/dtt01c8xkmqj5oochv9s.jpg'
    },
    {
      name: 'Ralphie May',
      image: 'https://res.cloudinary.com/dbm8xbouw/image/upload/v1776356794/scy0g4ottowprxb7yneu.png'
    }
  ];

  const movies = [
    {
      title: 'Super Troopers',
      image: 'https://res.cloudinary.com/dbm8xbouw/image/upload/v1789903603/ehqoxjqhxzp3j6oyqort.jpg'
    },
    {
      title: 'Austin Powers',
      image: 'https://res.cloudinary.com/dbm8xbouw/image/upload/v1789903111/q4vxy2avpubnekjnny7x.jpg'
    },
    {
      title: 'Dont Be a Menace',
      image: 'https://res.cloudinary.com/dbm8xbouw/image/upload/v1789903202/fek1quabfqtn9lnrno2m.jpg'
    },
    {
      title: 'Big Stan',
      image: 'https://res.cloudinary.com/dbm8xbouw/image/upload/v1789900570/n5ufr2n5dwzlc6arplfn.jpg'
    }
  ];

  const clips = [
    {
      title: 'Funny Clip 1',
      image: 'https://res.cloudinary.com/dnbbm9vzi/image/upload/v1789910632/image_2_bb7cin.jpg'
    },
    {
      title: 'Funny Clip 2',
      image: 'https://res.cloudinary.com/dnbbm9vzi/image/upload/v1789910632/image_3_rlyp5z.jpg'
    },
    {
      title: 'Funny Clip 3',
      image: 'https://res.cloudinary.com/dnbbm9vzi/image/upload/v1789910633/image_4_z3afxl.jpg'
    },
    {
      title: 'Funny Clip 4',
      image: 'https://res.cloudinary.com/dnbbm9vzi/image/upload/v1789910632/image_1_iuxmfe.jpg'
    }
  ];

  const stories = [
    {
      title: 'Guinness World Records Doubts Bonnie Blue’s 1,000 Men Stunt',
      image: 'https://res.cloudinary.com/dbm8xbouw/image/upload/v1767358067/g6u3t1zdzyt9abw6uukh.png'
    },
    {
      title: 'Zoom, Scandal, & the Birth of the Word "Obfuscation"',
      image: 'https://res.cloudinary.com/dbm8xbouw/image/upload/v1767357597/no0zgma0obikj5ve71p6.png'
    },
    {
      title: 'Anthropologist Answers What A Woman Is',
      image: 'https://res.cloudinary.com/dbm8xbouw/image/upload/v1767355856/puaajgxrygtuvccki7vo.png'
    },
    {
      title: 'Is Tim Dillon Faking Homosexuality For Show Business?',
      image: 'https://res.cloudinary.com/dbm8xbouw/image/upload/v1767355350/lgy70tuxso5fsnyfbe9z.png'
    }
  ];

const isAuthenticated = Boolean(localStorage.getItem('authToken'));

  return (
    <section
      className="my-5 py-5"
      style={{
        backgroundColor: '#f8f9fa',
        borderRadius: '24px',
        paddingLeft: '30px',
        paddingRight: '30px'
      }}
    >
      {/* Header */}
      <div className="text-center mb-5">
        <h2
          className="fw-bold mb-3"
          style={{ fontSize: '34px' }}
        >
          There's More Inside 🎭
        </h2>

        <p
          className="text-muted mx-auto"
          style={{
            maxWidth: '700px',
            fontSize: '18px'
          }}
        >
          Jessster Times is more than just articles. Create a free account
          to watch comedy, discover new content, save your favourites,
          and join the community.
        </p>
      </div>

      {/* Comedy Specials */}
      <div className="mb-5">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <div>
            <h3 className="fw-bold mb-1">🎤 Comedy Specials</h3>
            <p className="text-muted mb-0">
              Watch stand-up specials from only the rawest of comedians.
            </p>
          </div>

          <span className="text-muted small">
            Available with a free account
          </span>
        </div>

        <div className="row g-4">
          {comedians.map((comedian, index) => (
            <div
              key={index}
              className="col-6 col-md-3"
              >
                  <Link
                      to="/comedians"
                      style={{
                          textDecoration: 'none',
                          color: 'inherit'
                      }}
                  >
                      <div
                          className="card h-100 border-0 shadow-sm"
                          style={{
                              borderRadius: '16px',
                              overflow: 'hidden',
                              cursor: 'pointer',
                              transition: 'transform 0.2s ease, box-shadow 0.2s ease'
                          }}
                          onMouseEnter={(e) => {
                              e.currentTarget.style.transform = 'translateY(-6px)';
                              e.currentTarget.style.boxShadow = '0 10px 25px rgba(0, 0, 0, 0.12)';
                          }}
                          onMouseLeave={(e) => {
                              e.currentTarget.style.transform = 'translateY(0)';
                              e.currentTarget.style.boxShadow = '';
                          }}
                      >
                <img
                  src={comedian.image}
                  alt={comedian.name}
                  style={{
                    width: '100%',
                    height: '220px',
                    objectFit: 'cover'
                  }}
                />

                <div className="card-body text-center">
                  <h5 className="fw-bold mb-0">
                    {comedian.name}
                  </h5>
                </div>
              </div>
              </Link>
            </div>
          ))}
        </div>
      </div>

      {/* Comedy Movies */}
      <div className="mb-5">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <div>
            <h3 className="fw-bold mb-1">🎬 Comedy Movies</h3>
            <p className="text-muted mb-0">
              Discover classic comedies and enjoy something different.
            </p>
          </div>

          <span className="text-muted small">
            Available with a free account
          </span>
        </div>

        <div className="row g-4">
          {movies.map((movie, index) => (
            <div
              key={index}
              className="col-6 col-md-3"
            >
                <Link
                      to="/comedies"
                      style={{
                          textDecoration: 'none',
                          color: 'inherit'
                      }}
                  >
                      <div
                          className="card h-100 border-0 shadow-sm"
                          style={{
                              borderRadius: '16px',
                              overflow: 'hidden',
                              cursor: 'pointer',
                              transition: 'transform 0.2s ease, box-shadow 0.2s ease'
                          }}
                          onMouseEnter={(e) => {
                              e.currentTarget.style.transform = 'translateY(-6px)';
                              e.currentTarget.style.boxShadow = '0 10px 25px rgba(0, 0, 0, 0.12)';
                          }}
                          onMouseLeave={(e) => {
                              e.currentTarget.style.transform = 'translateY(0)';
                              e.currentTarget.style.boxShadow = '';
                          }}
                      >
                <img
                  src={movie.image}
                  alt={movie.title}
                  style={{
                    width: '100%',
                    height: '220px',
                    objectFit: 'cover'
                  }}
                />

                <div className="card-body text-center">
                  <h5 className="fw-bold mb-0">
                    {movie.title}
                  </h5>
                </div>
              </div>
              </Link>
            </div>
          ))}
        </div>
      </div>

      {/* Comedy Clips */}
      <div className="mb-5">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <div>
            <h3 className="fw-bold mb-1">📺 Comedy Clips</h3>
            <p className="text-muted mb-0">
              Quick laughs, funny moments and entertaining clips.
            </p>
          </div>

          <span className="text-muted small">
            Available with a free account
          </span>
        </div>

        <div className="row g-4">
          {clips.map((clip, index) => (
            <div
              key={index}
              className="col-6 col-md-3"
            >
                <Link
                      to="/clips"
                      style={{
                          textDecoration: 'none',
                          color: 'inherit'
                      }}
                  >
                      <div
                          className="card h-100 border-0 shadow-sm"
                          style={{
                              borderRadius: '16px',
                              overflow: 'hidden',
                              cursor: 'pointer',
                              transition: 'transform 0.2s ease, box-shadow 0.2s ease'
                          }}
                          onMouseEnter={(e) => {
                              e.currentTarget.style.transform = 'translateY(-6px)';
                              e.currentTarget.style.boxShadow = '0 10px 25px rgba(0, 0, 0, 0.12)';
                          }}
                          onMouseLeave={(e) => {
                              e.currentTarget.style.transform = 'translateY(0)';
                              e.currentTarget.style.boxShadow = '';
                          }}
                      >
                <img
                  src={clip.image}
                  alt={clip.title}
                  style={{
                    width: '100%',
                    height: '220px',
                    objectFit: 'cover'
                  }}
                />

                {/*
                <div className="card-body text-center">
                  <h5 className="fw-bold mb-0">
                    {clip.title}
                  </h5>
                </div>
                */}

              </div>
              </Link>
            </div>
          ))}
        </div>
      </div>

      {/* Community Stories */}
      <div className="mb-5">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <div>
            <h3 className="fw-bold mb-1">✍️ Community Stories</h3>
            <p className="text-muted mb-0">
              Write your own funny stories and get published on Jessster.
            </p>
          </div>

          <span className="text-muted small">
            Create your own stories
          </span>
        </div>

        <div className="row g-4">
          {stories.map((story, index) => (
            <div
              key={index}
              className="col-6 col-md-3"
            >
                <Link
                      to="/stories"
                      style={{
                          textDecoration: 'none',
                          color: 'inherit'
                      }}
                  >
                      <div
                          className="card h-100 border-0 shadow-sm"
                          style={{
                              borderRadius: '16px',
                              overflow: 'hidden',
                              cursor: 'pointer',
                              transition: 'transform 0.2s ease, box-shadow 0.2s ease'
                          }}
                          onMouseEnter={(e) => {
                              e.currentTarget.style.transform = 'translateY(-6px)';
                              e.currentTarget.style.boxShadow = '0 10px 25px rgba(0, 0, 0, 0.12)';
                          }}
                          onMouseLeave={(e) => {
                              e.currentTarget.style.transform = 'translateY(0)';
                              e.currentTarget.style.boxShadow = '';
                          }}
                      >
                <img
                  src={story.image}
                  alt={story.title}
                  style={{
                    width: '100%',
                    height: '180px',
                    objectFit: 'cover'
                  }}
                />

                <div className="card-body">
                  <h5 className="fw-bold">
                    {story.title}
                  </h5>
                </div>
              </div>
              </Link>
            </div>
          ))}
        </div>
      </div>

      {/* Account Features */}
      <div
        className="text-center mt-5 pt-4"
        style={{
          borderTop: '1px solid #dee2e6'
        }}
      >
        <h3 className="fw-bold mb-3">
          One free account. More to explore.
        </h3>

        <div className="d-flex flex-wrap justify-content-center gap-3 mb-4">
          <span className="badge bg-white text-dark border p-3">
            🎤 Comedy Specials
          </span>

          <span className="badge bg-white text-dark border p-3">
            🎬 Comedy Movies
          </span>

          <span className="badge bg-white text-dark border p-3">
            📺 Comedy Clips
          </span>

          <span className="badge bg-white text-dark border p-3">
            ✍️ Community Stories
          </span>

          <span className="badge bg-white text-dark border p-3">
            🔖 Save Articles
          </span>
        </div>

        <Link
          to={isAuthenticated ? "/dashboard" : "/register"}
          className="btn btn-dark btn-lg px-5 py-3 fw-bold"
          style={{
            borderRadius: '12px'
          }}
        >
          {isAuthenticated
            ? "Start Exploring →"
            : "Start Exploring for Free →"
          }
        </Link>

        {!isAuthenticated && (
          <p className="text-muted small mt-3 mb-0">
            Free to join. No subscription required.
          </p>
        )}


      </div>
    </section>
  );
};

export default ExploreFeatures;